module.exports = __webpack_public_path__ + "static/media/other.94b4fcda.png";